(function() {

    'use strict';

     eclipseApp.directive('seeFullDetailsContent', function () {

       return {
         restrict: 'EA',
         scope: {
           language: '@',
           templateFolder: '@'
         },
         transclude: true,
         templateUrl: function ($element, $attrs) {
           var templateFolder = $attrs.templateFolder || 'modules/my-account/prepaid/dashboard/refill/';
           return templateFolder + $attrs.bodyTemplate + '.html';
         },
         link: function ($scope) {

           $scope.clickButton = false;
           $scope.showFullDetails = function() {
               $scope.clickButton = true;
           };
           $scope.hideFullDetails = function() {
               $scope.clickButton = false;
           };
         }

       };
     });

})();
